import rejectedStopStore from './store'

export default class RejectedStopModule {
  name = 'rejectedStop'
  constructor({ store }) {
    store.registerModule(this.name, rejectedStopStore)
  }
}
